import React from "react";
import { useState, useEffect } from "react";
import ResumeCard from "./ResumeCard";
import { CurrencyOption, MoneyMask, ProcessValue } from "@/app/core/util/helpers/MoneyHelper";
import { PartnerHelper } from "@/app/core/util/helpers/PartnerHelper";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";
import QuotationItem from "./QuotationItem";

export default function QuotationStep({ infos, international, national, goBack, selectedNational, selectedInternational }) {
    const [total, setTotal] = useState({});
    const [internationalCarriers, setInternationalCarriers] = useState([]);
    const date = new Date();
    const [faster, setFaster] = useState(false);
    const [change, setChange] = useState(date.getTime());

    useEffect(() => {
        loadInfos()
    }, [international, national])

    useEffect(() => {
        processResults()
    }, [faster])

    useEffect(() => {
        loadInfos()
    }, [])

    function loadInfos() {
        setInternationalCarriers([]);
        setInternationalCarriers(international);
        setTotal(national);
        setTimeout(() => {
            notifyChange();
        }, 300)
        console.log("Resultados internacionais", international);
        if (international && international.length > 0) {
            notifyChange();
            console.log("Tentando mostrar", international);
        }
    }

    function notifyChange() {
        setChange(date.getTime());
    }

    function selectInternactional(item) {
        selectedInternational(item)
    }

    function processResults() {
        let base = internationalCarriers;
        if (base != undefined) {
            if (faster) {
                const response = base.sort(function (a, b) {
                    return a.transit_days - b.transit_days;
                });

                setInternationalCarriers(response);
                notifyChange();
            } else {
                // for (let s in base) {
                //     base[s].price = parseFloat(base[s].currency_payment_amount)
                // }
                const response = base.sort(function (a, b) {
                    return a.price - b.price;
                });

                setInternationalCarriers(response);
                notifyChange();
            }
        }
    }

    function reportValue(infos, index) {
        let ol = internationalCarriers;
        ol[index] = infos;
        setInternationalCarriers(ol);
        notifyChange();
    }

    return (
        <div className="">
            <div className="col-12 row">
                <div className="col-md-8">
                    {national && national.map(item => {
                        if (item.partner == PartnerHelper.Partner.TotalExpress) {
                            return <div className="block block-rounded block-fx-pop mb-2 js-appear-enabled animated fadeIn" data-toggle="appear">
                                <div className="block-content block-content-full border-left border-3x border-success">
                                    <div className="d-md-flex justify-content-md-between align-items-md-center">
                                        <div className="p-1 p-md-3">
                                            <h3 className="h4 font-w700 mb-1">{item && item.name}</h3>
                                            <p className="font-size-sm mb-2">
                                                {item && item.collectDate}
                                            </p>
                                            {item && item.deliveryDate ?
                                                <p className="font-size-sm text-muted mb-0">
                                                    {Translate(Message.DeliveryDate)} {item && item.deliveryDate}
                                                </p>
                                                : ""}
                                            <p className="font-size-sm text-muted mb-0">
                                                {Translate(Message.Taxes)} R${item && MoneyMask(item.taxCost, 2)}
                                            </p>
                                        </div>
                                        <div className="p-1 p-md-3">
                                            <a className="btn btn-outline-secondary btn-rounded px-3 mr-1 my-1" href="javascript:void(0)">
                                                R${MoneyMask(item.beforeTaxes, 2)}
                                            </a>
                                            <button className="btn btn-outline-success btn-rounded px-3 my-1" onClick={() => selectedNational(item)}>
                                                <i className="si si-check mr-1"></i> {Translate(Message.Advance)}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        } else if (item.partner == PartnerHelper.Partner.Correios) {
                            return <div className="block block-rounded block-fx-pop mb-2 js-appear-enabled animated fadeIn" data-toggle="appear">
                                <div className="block-content block-content-full border-left border-3x border-success">
                                    <div className="d-md-flex justify-content-md-between align-items-md-center">
                                        <div className="p-1 p-md-3">
                                            <h3 className="h4 font-w700 mb-1">{item && item.name}</h3>
                                            <p className="font-size-sm mb-2">
                                                {item && item.collectDate}
                                            </p>
                                            {item && item.deliveryDate ?
                                                <p className="font-size-sm text-muted mb-0">
                                                    {Translate(Message.DeliveryDate)} {item && item.deliveryDate}
                                                </p>
                                                : ""}
                                            <p className="font-size-sm text-muted mb-0">
                                                {Translate(Message.Taxes)} R${item && MoneyMask(item.taxCost, 2)}
                                            </p>
                                        </div>
                                        <div className="p-1 p-md-3">
                                            <a className="btn btn-outline-secondary btn-rounded px-3 mr-1 my-1" href="javascript:void(0)">
                                                R${MoneyMask(item.totalPrice, 2)}
                                            </a>
                                            <button className="btn btn-outline-success btn-rounded px-3 my-1" onClick={() => selectedNational(item)}>
                                                <i className="si si-check mr-1"></i>  {Translate(Message.Advance)}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    })}
                </div>
                {change && internationalCarriers ?
                    <div className="col-md-12">
                        <h3 className="text-muted">{Translate(Message.SelectCarrier)}</h3>
                        <div className="row">
                            <div className="col-md-8">
                                <div className="form-group row gutters-tiny items-push">
                                    <div className="col-6">
                                        <div className="custom-control custom-block custom-control-primary">
                                            <input type="radio" className="custom-control-input" id="db-travel-house-type-private" name="db-travel-house-type" checked={faster == false ? true : false} onClick={() => setFaster(false)} />
                                            <label className="custom-control-label" for="db-travel-house-type-private">
                                                <span className="d-block text-center">
                                                    {Translate(Message.Cheaper)}
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="custom-control custom-block custom-control-primary">
                                            <input type="radio" className="custom-control-input" id="db-travel-house-type-shared" name="db-travel-house-type" checked={faster == true ? true : false} onClick={() => setFaster(true)} />
                                            <label className="custom-control-label" for="db-travel-house-type-shared">
                                                <span className="d-block text-center">
                                                    {Translate(Message.Faster)}
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-8" style={{ zIndex: 99 }}>
                                {change && internationalCarriers.map((item, index) => {
                                    console.log("¹*******¹", item);
                                    return <QuotationItem item={item} index={index} selectInternactional={item => selectInternactional(item)} reportValue={infos => reportValue(infos, index)} />
                                })}
                            </div>
                            <div className="col-md-4">
                                <ResumeCard data={infos} />
                            </div>
                        </div>
                    </div>
                    : ""}
                <div className="col-md-4 pt-5" style={{ zIndex: 0 }}>
                    {/* <ResumeCard data={infos} /> */}
                </div>
            </div>
            <div className="col-md-12 text-center">
                <button type="button" className="btn btn-hero-lg btn-hero-white" onClick={() => goBack()}>
                    <i className="fa fa-arrow-left mr-2"></i>  {Translate(Message.GoBack)}
                </button>
            </div>
            {/* <button type="button" className="btn btn-hero-lg btn-hero-success" onClick={()=> endBoxes()}>
                    Avançar <i className="fa fa-arrow-right ml-2"></i>
                </button> */}
        </div>
    )
}